import { Fragment, useState } from 'react';
import { InputAdornment, Menu, MenuItem } from '@mui/material';

export default function AdornmentField({ value, position, values, onChange }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const label = (values.find((item) => item.value === value) || values[0])
    .label;

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const handleItemClick = (value) => () => {
    onChange(value);
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <InputAdornment
        position={position}
        aria-controls="adornment-menu"
        aria-haspopup="true"
        style={{ cursor: 'pointer' }}
        onClick={handleClick}
      >
        {label}
      </InputAdornment>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {(values || []).map((item) => (
          <MenuItem
            key={item.value || item}
            value={item.value || item}
            onClick={handleItemClick(item.value || item)}
          >
            {item.label || item}
          </MenuItem>
        ))}
      </Menu>
    </Fragment>
  );
}
